import { useCallback, useState } from 'react';
import { myDeskService } from '../../services/myDeskService';
import { useFlashMessage } from '../FlashMessage';

/**
 * Pin an object from a list row or menu, with flash feedback. For a header
 * button with a persistent pinned state use PinToDeskButton instead.
 */
const usePinToDesk = () => {
  const { showSuccess, showError } = useFlashMessage();
  const [busy, setBusy] = useState(false);

  const pin = useCallback(async (entityType, objectId) => {
    if (!objectId) return false;
    setBusy(true);
    try {
      await myDeskService.pin(entityType, objectId);
      showSuccess('Pinned to My Workspace.');
      return true;
    } catch (err) {
      console.error('My Desk: pin failed', err);
      showError(err?.response?.data?.error || 'This item could not be pinned.');
      return false;
    } finally {
      setBusy(false);
    }
  }, [showSuccess, showError]);

  return { pin, busy };
};

export default usePinToDesk;
